export class DownloadThumbSlider {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('js-download_thumb') === null) return
      let thumb = document.getElementById('js-download_thumb')
      const targetList = document.querySelectorAll('.js-download_thumb_trg')
      const node = Array.prototype.slice.call(targetList, 0)

      node.forEach((elm) => {
        elm.addEventListener('click', (event) => {
          console.log(elm)
          let $this = event.currentTarget
          let imgSrc = $this.innerHTML
          thumb.innerHTML = imgSrc
        })
      })
    })
  }
}
